module.exports = __webpack_public_path__ + "img/SES_38083050.23389351.jpg";